import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { GraphQLErrorMessage, Paragraph, Switch, useToasts } from '@treams/treams-ui';

export function GrowthPathExclusionToggle({
	jobTitle,
}: {
	jobTitle: Pick<graphql.JobTitle, 'id' | 'excludedFromGrowthPath'>;
}) {
	const { t } = useTranslation();
	const { addToast } = useToasts();
	const growPathEnabled = useFeature(graphql.FeatureName.GrowPath);
	const styrQuery = graphql.useViewerStyrConfigQuery({ skip: !growPathEnabled });
	const [setExclusion, { loading, error }] = graphql.useSetJobTitleGrowthPathExclusionMutation();

	if (!growPathEnabled || !styrQuery.data?.viewer?.workspace?.styrConfig?.enabled) {
		return null;
	}

	const handleChange = async (excluded: boolean) => {
		try {
			await setExclusion({ variables: { input: { id: jobTitle.id, excluded } } });
			addToast(t('common.settings.jobTitles.edit.success'), {
				appearance: 'success',
				autoDismiss: true,
			});
		} catch {
			// error state is shown via GraphQLErrorMessage
		}
	};

	return (
		<Box>
			<Switch
				label={t('jobTitle.growthPathExclusion.label')}
				on={jobTitle.excludedFromGrowthPath}
				disabled={loading}
				onChange={handleChange}
			/>
			<Paragraph color="slateBlue" mt={1}>
				{t('jobTitle.growthPathExclusion.description')}
			</Paragraph>
			{error?.graphQLErrors[0] && (
				<Box mt={2}>
					<GraphQLErrorMessage error={error.graphQLErrors[0]} />
				</Box>
			)}
		</Box>
	);
}
